import { c as _c } from "react/compiler-runtime";
import { keepPreviousData } from "@tanstack/query-core";
import { useQuery } from "@tanstack/react-query";
import { ApiGroupFull } from "@/generated/models/ApiGroupFull";
import { commonApiFetch } from "@/services/api/common-api";
import GroupCard from "./GroupCard";
import { QueryKey } from "@/components/react-query-wrapper/ReactQueryWrapper";
import ChatItemHrefButtons from "@/components/waves/ChatItemHrefButtons";
export default function GroupCardChat(t0) {
  const $ = _c(17);
  const {
    href,
    groupId
  } = t0;
  let t1;
  let t2;
  if ($[0] !== groupId) {
    t1 = [QueryKey.GROUP, groupId];
    t2 = async () => await commonApiFetch({
      endpoint: `groups/${groupId}`
    });
    $[0] = groupId;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  const t3 = !!groupId;
  let t4;
  if ($[3] !== t1 || $[4] !== t2 || $[5] !== t3) {
    t4 = {
      queryKey: t1,
      queryFn: t2,
      placeholderData: keepPreviousData,
      enabled: t3
    };
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const {
    data: group
  } = useQuery(t4);
  let t5;
  if ($[7] !== group || $[8] !== groupId || $[9] !== href) {
    t5 = <div className="tw-flex-1 tw-min-w-0"><GroupCard group={group} userPlaceholder={href} titlePlaceholder={groupId} /></div>;
    $[7] = group;
    $[8] = groupId;
    $[9] = href;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const t6 = `/network?group=${groupId}`;
  let t7;
  if ($[11] !== href || $[12] !== t6) {
    t7 = <ChatItemHrefButtons href={href} relativeHref={t6} />;
    $[11] = href;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t5 || $[15] !== t7) {
    t8 = <div className="tw-flex tw-items-stretch tw-w-full tw-gap-x-1">{t5}{t7}</div>;
    $[14] = t5;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  return t8;
}